export const messages = {
  en: {
    attendanceAuditStaffBind: {
      title: 'Audit Staff Bind',
      currentStaffLabel: 'Audited Staff',
      currentStaffTip: 'Tip: only staff under this list will be shown as audit targets',
      businessTypeLabel: 'Business Type',
      leaveOption: 'Leave',
      overtimeOption: 'Overtime',
      auditStaffLabel: 'Audit Staff',
      add: 'Add Audit Staff',
      delete: 'Delete',
      back: 'Back',
      search: 'Search',
      reset: 'Reset',
      table: {
        staffId: 'Staff ID',
        staffName: 'Staff Name',
        auditUserId: 'Audit User ID',
        auditUserName: 'Audit User Name',
        remark: 'Remark',
        state: 'Status',
        businessType: 'Business Type',
        createTime: 'Create Time'
      },
      selectStaffTip: 'Please select a staff',
      selectStaffFirst: 'Please select staff first',
      selectCurrentStaffFirst: 'Please pick the audited staff first',
      deleteTitle: 'Confirm Delete',
      deleteConfirm: 'Are you sure to delete this audit staff?',
      fetchError: 'Failed to fetch audit staff list',
      saveSuccess: 'Save successfully',
      saveFailed: 'Save failed',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed',
      auditType: 'Audit Type',
      auditLeave: 'Leave Audit',
      auditOvertime: 'Overtime Audit',
      stateOn: 'On',
      stateOff: 'Off'
    }
  },
  zh: {
    attendanceAuditStaffBind: {
      title: '绑定审核人员',
      currentStaffLabel: '被审核员工',
      currentStaffTip: '提示：列表中只会展示该员工的审核人',
      businessTypeLabel: '业务类型',
      leaveOption: '请假',
      overtimeOption: '加班',
      auditStaffLabel: '审核人员',
      add: '添加审核人员',
      delete: '删除',
      back: '返回',
      search: '查询',
      reset: '重置',
      table: {
        staffId: '员工ID',
        staffName: '员工姓名',
        auditUserId: '审核人ID',
        auditUserName: '审核人',
        remark: '备注',
        state: '状态',
        businessType: '业务类型',
        createTime: '创建时间'
      },
      selectStaffTip: '请选择员工',
      selectStaffFirst: '请先选择员工',
      selectCurrentStaffFirst: '请先选择被审核员工',
      deleteTitle: '确认删除',
      deleteConfirm: '确定要删除该审核人员吗？',
      fetchError: '获取审核人员列表失败',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      auditType: '审批类型',
      auditLeave: '请假审批',
      auditOvertime: '加班审批',
      stateOn: '启用',
      stateOff: '禁用'
    }
  }
}
